jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

function ToggleList2(IDS) {
  HideRange('ulist2','div',IDS);  // not required unless using 'HideRange()' below
  var CState = document.getElementById(IDS);
  if (CState.style.display != "block") { CState.style.display = "block"; }
                                  else { CState.style.display = "none"; }
}
function HideRange(sect,elTag,IDS) {
  var ContentObj = document.getElementById(sect);
  var AllContentDivs = ContentObj.getElementsByTagName(elTag);
  for (i=0; i<AllContentDivs.length; i++) {
    if (IDS != AllContentDivs[i].id) { AllContentDivs[i].style.display="none"; }
  }
}

var acc = document.getElementsByClassName("myaccordion");
var panel = document.getElementsByClassName('mypanel');

for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
    	var setClasses = !this.classList.contains('active');
        setClass(acc, 'active', 'remove');
        setClass(panel, 'show', 'remove');
        
       	if (setClasses) {
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show");
        }
    }
}

function setClass(els, className, fnName) {
    for (var i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
    }
}
